import DocumentHeader from './DocumentHeader';

export default DocumentHeader;
